// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xxXtgl2Do0JVoKIK8uGU{display:flex;align-items:center}.du4zGRrzgJQHAAagFXKB{margin-left:var(--spacing-xxxSmall)}`, "",{"version":3,"sources":["webpack://./src/App/views/SchoolDataRoleSelection/ModalPending.module.scss"],"names":[],"mappings":"AAAA,sBAAa,YAAY,CAAC,kBAAkB,CAAC,sBAAO,mCAAmC","sourcesContent":[".dialogTitle{display:flex;align-items:center}.title{margin-left:var(--spacing-xxxSmall)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogTitle": `xxXtgl2Do0JVoKIK8uGU`,
	"title": `du4zGRrzgJQHAAagFXKB`
};
export default ___CSS_LOADER_EXPORT___;
